function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { Fade, Slide, Zoom } from 'react-slideshow-image';
import mergeStyles from '../utils/StyleMerge';
import withSizes from '../utils/Sizes';
import deepmerge from 'deepmerge';
import SplitWrappedLines from './SplitWrappedLines';
import Radium from 'radium';
import Reveal from 'react-reveal';
import './animations.css';

class Slideshow extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderSlide", () => {
      const {
        slides,
        options,
        styles,
        getStyle
      } = this.props;

      const _styles = deepmerge(styles, slideStyles);

      return (
        /*#__PURE__*/
        React.createElement(Slide, _extends({}, options, {
          className: "slideshowWrapper"
        }), slides.map((slide, index) => {
          return (
            /*#__PURE__*/
            React.createElement("div", {
              key: index,
              style: _styles.slide
            },
            /*#__PURE__*/
            React.createElement("div", {
              style: _styles.imageWrapper
            }, slide.source &&
            /*#__PURE__*/
            React.createElement("img", {
              src: slide.source,
              style: _styles.image,
              alt: `img${index}`
            })),
            /*#__PURE__*/
            React.createElement("div", {
              style: _styles.titleWrapper
            }, slide.title.map((title, subIndex) => {
              return index === 0 ?
              /*#__PURE__*/
              React.createElement(Reveal, {
                effect: "fadeInUp-Header",
                duration: 1000
              },
              /*#__PURE__*/
              React.createElement("div", {
                key: subIndex,
                style: getStyle(title.style)
              }, title.text)) :
              /*#__PURE__*/
              React.createElement("div", {
                key: subIndex,
                style: getStyle(title.style)
              }, title.text);
            })))
          );
        }))
      );
    });

    _defineProperty(this, "renderFade", () => {
      const {
        slides,
        options,
        styles,
        getStyle
      } = this.props;

      const _styles = deepmerge(styles, fadeStyles);

      return (
        /*#__PURE__*/
        React.createElement(Fade, _extends({}, options, {
          className: "slideshowWrapper"
        }), slides.map((slide, index) => {
          return (
            /*#__PURE__*/
            React.createElement("div", {
              key: index,
              style: getStyle(_styles.slide)
            },
            /*#__PURE__*/
            React.createElement("div", {
              style: getStyle(_styles.imageWrapper)
            }, slide.source &&
            /*#__PURE__*/
            React.createElement("img", {
              src: slide.source,
              style: getStyle(_styles.image),
              alt: `img${index}`
            })),
            /*#__PURE__*/
            React.createElement("div", {
              style: getStyle(_styles.titleWrapper)
            }, options.splitWrappedLines ?
            /*#__PURE__*/
            React.createElement(SplitWrappedLines, {
              text: slide.title,
              styles: {
                line: styles.titleLine
              }
            }) : slide.title.map((title, subIndex) => {
              return index === 0 ?
              /*#__PURE__*/
              React.createElement(Reveal, {
                effect: "fadeInUp-Header",
                duration: 1000
              },
              /*#__PURE__*/
              React.createElement("span", {
                key: subIndex,
                style: getStyle(title.style)
              }, title.text)) :
              /*#__PURE__*/
              React.createElement("span", {
                key: subIndex,
                style: getStyle(title.style)
              }, title.text);
            }), slide.button ?
            /*#__PURE__*/
            React.createElement("div", {
              style: getStyle(styles.buttonWrapper)
            },
            /*#__PURE__*/
            React.createElement("div", {
              onClick: slide.button.onClick,
              key: `button-${index}`,
              style: getStyle(styles.button)
            }, slide.button.text)) : null))
          );
        }))
      );
    });

    _defineProperty(this, "renderZoom", () => {});
  }

  render() {
    const {
      styles,
      getStyle,
      type
    } = this.props;
    const {
      renderSlide,
      renderFade,
      renderZoom
    } = this;
    let slideshow = null;

    switch (type) {
      case 'slide':
        slideshow = renderSlide();
        break;

      case 'zoom':
        slideshow = renderZoom();
        break;

      default:
        slideshow = renderFade();
        break;
    }

    return (
      /*#__PURE__*/
      React.createElement("div", {
        style: getStyle(styles.container)
      }, slideshow)
    );
  }

}

const fadeStyles = {};
const slideStyles = {};
const defaultStyles = {
  button: {
    display: 'inline-block',
    cursor: 'pointer'
  },
  buttonWrapper: {},
  titleLine: {},
  container: {
    width: '100%',
    height: '100%'
  },
  slide: {
    position: 'relative',
    width: '100%',
    height: '100%'
  },
  imageWrapper: {
    width: '100%',
    height: '100%'
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  titleWrapper: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center'
  }
};
export default mergeStyles(defaultStyles)(withSizes(Radium(Slideshow)));